import { resolveAppLanguage } from '../../../shared/config';

export function selectHomeDashboardStatementMonth(
  language: string,
  date: Date = new Date(),
): string {
  const statementMonthLanguage = resolveAppLanguage(language);

  return new Intl.DateTimeFormat(statementMonthLanguage, {
    month: 'long',
  }).format(date);
}

export function useHomeDashboardStatementMonth(language: string): string {
  return selectHomeDashboardStatementMonth(language);
}
